import { Navigate, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AdminShell } from './layouts/AdminShell';
import { LoginPage } from './pages/LoginPage';
import { HomePage } from './pages/HomePage';
import { OrgsPage } from './pages/OrgsPage';
import { OrgDetailsPage } from './pages/OrgDetailsPage';
import { TenantsPage } from './pages/TenantsPage';
import { StaffPage } from './pages/StaffPage';
import { RolesPage } from './pages/RolesPage';
import { AuditPage } from './pages/AuditPage';
import { FeaturesPage } from './pages/FeaturesPage';
import { AccountSettingsPage } from './pages/AccountSettingsPage';
import { TasksPage } from './pages/TasksPage';
import { BillingPage } from './pages/BillingPage';
import type { RootState } from './store/index';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const accessToken = useSelector((state: RootState) => state.auth.accessToken);
  if (!accessToken) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <AdminShell />
          </RequireAuth>
        }
      >
        <Route index element={<HomePage />} />
        <Route path="orgs" element={<OrgsPage />} />
        <Route path="orgs/:orgId" element={<OrgDetailsPage />} />
        <Route path="tenants" element={<TenantsPage />} />
        <Route path="roles" element={<RolesPage />} />
        <Route path="staff" element={<StaffPage />} />
        <Route path="tasks" element={<TasksPage />} />
        <Route path="audit" element={<AuditPage />} />
        <Route path="features" element={<FeaturesPage />} />
        <Route path="billing" element={<BillingPage />} />
        <Route path="account" element={<AccountSettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
